<div id="company" class="page-layout emma simple carded fullwidth">
    <div class="header accent">
        @if (pageType == "edit") {
            <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/admin/companies'">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }

        @if (pageType == "new") {
            <h1>{{ "COMPANIES.Company" | translate }} - {{ "COMPANIES.Create" | translate }}</h1>
        }
        @if (pageType == "edit") {
            <h1>{{ "COMPANIES.Company" | translate }} - {{ company.name }}</h1>
        }
    </div>

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group [backgroundColor]="'header'">
                <mat-tab label="{{ 'COMPANIES.BasicInfo' | translate }}">
                    <div class="content">
                        <form name="productForm" [formGroup]="companyForm" class="company">
                            <div class="section">
                                <h2 class="section__title">
                                    <mat-icon>business</mat-icon>
                                    <div>{{ "COMPANIES.Company" | translate }}</div>
                                </h2>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "COMPANIES.CompanyName" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="name"
                                        formControlName="name"
                                        placeholder="{{ 'COMPANIES.CompanyName' | translate }}"
                                        required
                                    />
                                </mat-form-field>
                            </div>

                            <div class="section">
                                <h2 class="section__title">
                                    <mat-icon>mail_circle</mat-icon>
                                    <div>{{ "COMPANIES.Address" | translate }}</div>
                                </h2>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "COMPANIES.Street" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="street"
                                        formControlName="street"
                                        placeholder="{{ 'COMPANIES.Street' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "COMPANIES.City" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="city"
                                        formControlName="city"
                                        placeholder="{{ 'COMPANIES.City' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "COMPANIES.ZipCode" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="zipCode"
                                        formControlName="zipCode"
                                        placeholder="{{ 'COMPANIES.ZipCode' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "COMPANIES.Country" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="country"
                                        formControlName="country"
                                        placeholder="{{ 'COMPANIES.Country' | translate }}"
                                        required
                                    />
                                </mat-form-field>
                            </div>

                            <div class="form-action">
                                @if (pageType == "new") {
                                    <button
                                        mat-raised-button
                                        class="button-save"
                                        color="primary"
                                        [disabled]="companyForm.invalid"
                                        (click)="add()"
                                    >
                                        {{ "COMPANIES.ADD" | translate }}
                                    </button>
                                }
                                @if (pageType == "new") {
                                    <button mat-raised-button (click)="cancel()">
                                        {{ "COMPANIES.CANCEL" | translate }}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </mat-tab>
                @if (pageType == "edit") {
                    <mat-tab label="{{ 'COMPANIES.Projects' | translate }}">
                        <div class="project-content" fusePerfectScrollbar>
                            <app-project-list selectionControl="toggle" (rowSelect)="onProjectCheck($event)"></app-project-list>
                        </div>
                    </mat-tab>
                }
            </mat-tab-group>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
